<!-- <div class="custom-file">
	<input type="file" [disabled]="disabled" class="custom-file-input" id="customFile" (change)="onFileChange($event, index)">
	<label class="custom-file-label" for="customFile">
		<span *ngIf="index === undefined; else elseBlock">{{fileValidation.placeholder}}</span>
		<ng-template #elseBlock>
			<span *ngIf="names[index]!==''; else messageBlock">{{names[index]}}</span>
			<ng-template #messageBlock>
				{{fileValidation.placeholder}}
			</ng-template>
		</ng-template>
	</label>
</div> -->
<ng-container *ngIf="documentForm; else elseBlock">
	<div class="m-form__section m-form__section--first" [formGroup]="documentForm">
		<div class="m-form__heading" style="margin-bottom: 30px;">
			<h5 class="m-form__heading-title">
				UPLOAD REQUIRED FILES FOR THE MANDATORY CATEGORIES
			</h5>
			<label style="color: #ef7e22">Appropriate file types (pdf, docx, xlsx, zip) & file size upto 5MB</label>
		</div>
		<ng-container formArrayName="docketDocuments">
			<ng-container *ngFor="let docket of documentForm.get('docketDocuments')['controls']; let i = index;">
				<!--begin::Docket review array Upload-->
				<ng-container [formGroupName]="i">
					<ng-container *ngIf="reviews">
						<div class="form-group m-form__group row" style="margin-bottom: 25px;">
							<label class="col-lg-1 col-form-label"></label>
							<label class="col-lg-3 col-form-label">
								{{fileValidation.label[i]}}
							</label>
							<div class="col-lg-6">
								<app-file-download
									[fileURL]="(reviews[i].documentURL).replace('http://nsdcdev.s3.amazonaws.com/', '')"
									buttonText="Download File">
								</app-file-download>
							</div>
						</div>
						<app-review-type [column]="true" [isComplaint]="reviews[i].isCompliant"
							[description]="reviews[i].reviewComment "></app-review-type>
						<div class="form-group m-form__group row" style="margin-bottom: 25px;"
							*ngIf="!reviews[i].isCompliant">
							<label class="col-lg-1 col-form-label"></label>
							<label class="col-lg-3 col-form-label">Upload New File</label>
							<div class="custom-file col-lg-4" style="margin-left:15px;">
								<input type="file" class="custom-file-input" id="customFile"
									(click)="findDocket('files',$event, i)" (change)="onFileChange($event, 'files', i)">
								<label class="custom-file-label" for="customFile">
									<span
										*ngIf="documentForm && (documentForm.value.docketDocuments[i].documentName !== null && documentForm.value.docketDocuments[i].documentName !== ''); else placeHolderBlock">
										{{documentForm.value.docketDocuments[i].documentName}}
									</span>
									<ng-template #placeHolderBlock>
										<span>
											{{filesPlaceholder[i]}}
										</span>
									</ng-template>
								</label>

								<span class="m-form__help" *ngIf="message[i] !== 'Success'" style="color: red">
									{{message[i]}}
								</span>
							</div>
							<button type="button" style="margin-left: 10px;" [disabled]="!files[i]"
								class="btn btn-secondary" (click)="uploadDocument('files', i)">
								Upload
							</button>
							<i class="fa fa-check" style="color: green; margin-top: 5px; margin-left: 5px;"
								*ngIf="message[i] === 'Success'"></i>
							<!-- <i class="fa fa-remove" style="color: red; margin-top: 5px; margin-left: 5px;" *ngIf="removeFiles[i]"></i> -->
						</div>
					</ng-container>
					<!--end::Docket review array Upload-->


					<!--begin::Docket array Upload-->
					<div class="form-group m-form__group row" style="margin-bottom: 22px;margin-top: 22px;"
						*ngIf="upload">
						<label class="col-lg-3 col-form-label">
							{{fileValidation.label[i]}}
							<span style="color: red"
								*ngIf="fileValidation.astrisk && fileValidation.label[i+1]">*</span>
						</label>
						<label class="col-lg-1 col-form-label"></label>
						<div class="custom-file col-lg-4">
							<input type="file" class="custom-file-input" id="customFile"
								[disabled]="FileinputDisabled" (click)="findDocket('files',$event, i)"
								(change)="onFileChange($event, 'files', i)">
							<label class="custom-file-label" for="customFile">
								{{filesPlaceholder[i]}}
							</label>
							<span class="m-form__help" *ngIf="message[i] !== 'Success'" style="color: red">
								{{message[i]}}
							</span>
						</div>
						<button type="button" style="margin-left: 10px;" [disabled]="!files[i]"
							class="btn btn-secondary" (click)="uploadDocument('files', i)">
							Upload
						</button>
						<i class="fa fa-check" style="color: green; margin-top: 5px; margin-left: 5px;" *ngIf="(message[i] === 'Success') || (documentForm && (documentForm.value.docketDocuments[i].documentName !== null &&
							documentForm.value.docketDocuments[i].documentName !== ''))"></i>
						<button type="button" style="margin-left: 10px;" class="btn btn-secondary"
							[disabled]="FileinputDisabled" (click)="showRemarksToggle(i)">
							{{ !showRemarks[i] ? 'Add Remarks' : 'Discard Remarks'}}
						</button>
					</div>
					<div class="offset-4 col-4" *ngIf="errorMessage === fileValidation.label[i]">
						<span *ngIf="fileValidation.label[i] !== 'Other Documents'" style="font-size: 12px;color: red;">
							{{errorMessage }} {{isMandatory}}</span>
					</div>
					<div class="row" *ngIf="!FileinputDisabled">
						<textarea name="remarks" *ngIf="showRemarks[i]" class="form-control col-md-4 offset-md-4"
							formControlName="documentRemarks" placeholder="Remarks for {{fileValidation.label[i]}}">
						</textarea>
					</div>
					<div class="row" *ngIf="FileinputDisabled">
						<textarea name="remarks" class="form-control col-md-4 offset-md-4"
							formControlName="documentRemarks" [disabled]="FileinputDisabled"
							placeholder="Remarks for {{fileValidation.label[i]}}">
						</textarea>
					</div>
					<div class="form-group m-form__group row">
						<div class="col-md-4 offset-4">
							<app-file-download [buttonTag]="false"
								[fileURL]="documentForm.get('docketDocuments').value[i].documentURL"
								[buttonText]="documentForm.get('docketDocuments').value[i].documentName">
							</app-file-download>
							<span *ngIf="(message[i] === 'Success')"><i class="fa fa-window-close" aria-hidden="true"
									(click)="deleteFile(i)"></i>
							</span>
							<!-- <a (click)="viewFile(documentForm.get('docketDocuments').value[i].documentURL)" target="_blank"  rel="noopener"><small [attr.title]="documentForm.get('docketDocuments').value[i].documentName">{{documentForm.get('docketDocuments').value[i].documentName}} </small></a> -->
						</div><br>
					</div>
					<!--end::Docket array Upload-->
				</ng-container>
			</ng-container>
		</ng-container>
	</div>
</ng-container>

<!--Single file upload-->
<ng-template #elseBlock>
	<div [class]="multiColumn">
		<input type="file" class="custom-file-input " id="customFile" [disabled]="FileinputDisabled"
			[disabled]="fileValidation?.disable ? true :  null" (click)="findDocket('file', $event, -1)"
			(change)="onFileChange($event, 'file') ">
		<label class="custom-file-label overflow-style" for="customFile">
			<span
				*ngIf="documentForm && (documentForm.value[objectsList[0]] !== null && documentForm.value[objectsList[0]] !== ''); else placeHolderBlock">
				{{documentForm.value[objectsList[0]]}}
			</span>
			<ng-template #placeHolderBlock>
				<span>
					{{placeholder}}
				</span>
			</ng-template>
		</label>
	</div>
	<button type="button" class="btn btn-secondary " [disabled]="!file || uploadDisable"
		(click)="uploadDocument('file')" style="margin-top:11px; ">
		Upload
	</button>
	<i class="fa fa-check " style="color: green" *ngIf="errorMessage==='Success' && placeholder !== 'Choose File'"></i>
	<!-- <i class="fa fa-remove" style="color: red; margin-top: 5px; margin-left: 5px;" *ngIf="remove"></i> -->
	<div class="form-group m-form__group row" style="padding-bottom: 0px !important">
		<!-- <div class="col-lg-4 "></div> -->
		<!-- <pre>{{docketForm.get(objectsList[0]) | json}}
		</pre> -->
		<div class="col-lg-8">
			<span style="font-size: 12px;color: red;" *ngIf="errorMessage !=='Success' ">{{errorMessage}}</span>
			<app-form-control-messages *ngIf="docketForm" [control]="docketForm.get(objectsList[0])"
				[name]="'Document'">
			</app-form-control-messages>
		</div>
	</div>
	<div class="form-group m-form__group row" style="padding-top: 0px !important">
		<div class="col-lg-8">
			<span style="color: blue;font-size: 12px;">{{fileValidation?.defaultMessage}}</span>
		</div>
	</div>
</ng-template>